import React, { Fragment, useState, useEffect, Suspense } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./bootstrap.min.css";

import Bunexe_service from "./Bunexe_service";
import NavbarBunexe from "./components/NavbarBunexe";
import Login from "./Login";
import Bienvenue from "./components/Bienvenue";
import NotFound from "./components/NotFound";

import Bienvenue_perm from "./components/perm_engligne/Bienvenue_perm";
import Mat_anticipees from "./components/mat_anticipees/Mat_anticipees";
import Saisie_notes_bac from "./components/saisie_notes_bac/Saisie_notes_bac";
import Enic from "./components/enic/Enic";
import ResultatBac from "./components/resultat_bac/ResultatBac";
import Stat_global from "./components/Stat_global";
import Verification_Inscription from "./components/Verification_Inscription";
import VerifDiplome from "./components/VerifDiplome";
import Intro from "./components/e_document/e-diplome/Intro";
import Ediplome from "./components/E_diplome";

// Fonction d'importation Lazy avec préchargement
const ReactLazyPreload = (importStatement) => {
  const Component = React.lazy(importStatement);
  Component.preload = importStatement;
  return Component;
};

// Chargement paresseux (Lazy loading) des modules
const Ecole = ReactLazyPreload(() => import("./components/ecoles/Ecole"));
const Nouveau = ReactLazyPreload(() => import("./components/Nouveau"));
const Capiste = ReactLazyPreload(() => import("./components/Capiste"));
const Neuvieme = ReactLazyPreload(() => import("./components/9AF/Neuvieme"));
const SecI = ReactLazyPreload(() => import("./components/secI/SecI"));
const SecII = ReactLazyPreload(() => import("./components/secII/SecII"));
const SecIII = ReactLazyPreload(() => import("./components/secIII/SecIII"));
const SecIV = ReactLazyPreload(() => import("./components/secIV/SecIV"));
const Philo = ReactLazyPreload(() => import("./components/philo/Philo"));
const CreerUtilisateur = ReactLazyPreload(
  () => import("./components/utilisateur/CreerUtilisateur"),
);
const PermPh = ReactLazyPreload(() => import("./components/permPH/permPH"));
const PermNs = ReactLazyPreload(() => import("./components/permNS/permNS"));
const Eni = ReactLazyPreload(() => import("./components/eni/Eni"));
const ChangerMot2Passe = ReactLazyPreload(
  () => import("./components/utilisateur/ChangerMot2Passe"),
);
const PeriodeSaisie = ReactLazyPreload(
  () => import("./components/utilisateur/PeriodeSaisie"),
);

// Composant de chargement visuel
const LoadingFallback = () => (
  <div className="d-flex justify-content-center" style={{ marginTop: "40px" }}>
    <div className="spinner-grow text-primary mr-2" role="status">
      <span className="sr-only">Chargement...</span>
    </div>
    <div className="spinner-grow text-secondary" role="status">
      <span className="sr-only">Chargement...</span>
    </div>
  </div>
);

toast.configure();

function App() {
  const [isLogin, setIsLogin] = useState(false);
  const [info_, setInfo_] = useState({});
  const [code_dept, setCode_dept] = useState("");
  const [mon_ecole, setMon_ecole] = useState({});
  const url_ = Bunexe_service.url;

  const monEcole = async (username) => {
    try {
      const res = await fetch(`${url_}/ecole/${username}`, {
        method: "GET",
        headers: { "auth-token": localStorage.token },
      });
      const parseData1 = await res.json();
      setMon_ecole((prev) => ({ ...prev, ...parseData1 }));
    } catch (err) {
      console.error("Erreur récupération école:", err.message);
    }
  };

  const quiSuisje = async () => {
    try {
      const res = await fetch(`${url_}/auth/info`, {
        method: "POST",
        headers: { "auth-token": localStorage.token },
      });

      const parseData = await res.json();
      if (parseData.username) {
        setIsLogin(true);
      }
      setCode_dept(parseData.code_dept);
      setInfo_((prev) => ({ ...prev, ...parseData }));

      if (parseData.role_id === "DI") {
        monEcole(parseData.username);
      } else {
        setMon_ecole(null);
      }
    } catch (err) {
      console.error("Erreur d'authentification utilisateur:", err);
    }
  };

  useEffect(() => {
    if (localStorage.token) {
      quiSuisje();
    }
  }, [isLogin]);

  useEffect(() => {
    Neuvieme.preload();
    PermPh.preload();
    CreerUtilisateur.preload();
  }, []);

  return (
    <Fragment>
      <NavbarBunexe isLogin={isLogin} info={info_} setIsLogin={setIsLogin} />
      <Suspense fallback={<LoadingFallback />}>
        <Switch>
          <Route
            exact
            path="/"
            render={(props) =>
              !isLogin ? (
                <Login {...props} setIsLogin={setIsLogin} />
              ) : (
                <Bienvenue />
              )
            }
          />
          <Route
            exact
            path="/bienvenue"
            render={(props) =>
              !isLogin ? (
                <Login {...props} setIsLogin={setIsLogin} />
              ) : (
                <Bienvenue />
              )
            }
          />

          <Route
            path="/board"
            render={(props) =>
              isLogin ? (
                <Stat_global
                  {...props}
                  setIsLogin={setIsLogin}
                  code_dept={code_dept}
                  info={info_}
                  mon_ecole={mon_ecole}
                />
              ) : (
                <Redirect to="/" />
              )
            }
          />

          <Route
            path="/neuvieme"
            render={(props) =>
              isLogin ? (
                <Neuvieme
                  {...props}
                  setIsLogin={setIsLogin}
                  code_dept={code_dept}
                  info={info_}
                  mon_ecole={mon_ecole}
                />
              ) : (
                <Redirect to="/" />
              )
            }
          />

          <Route
            path="/sec1"
            render={(props) =>
              isLogin ? (
                <SecI
                  {...props}
                  setIsLogin={setIsLogin}
                  code_dept={code_dept}
                  info={info_}
                  mon_ecole={mon_ecole}
                />
              ) : (
                <Redirect to="/" />
              )
            }
          />

          <Route
            path="/sec2"
            render={(props) =>
              isLogin ? (
                <SecII
                  {...props}
                  setIsLogin={setIsLogin}
                  code_dept={code_dept}
                  info={info_}
                  mon_ecole={mon_ecole}
                />
              ) : (
                <Redirect to="/" />
              )
            }
          />

          <Route
            path="/sec3"
            render={(props) =>
              isLogin ? (
                <SecIII
                  {...props}
                  setIsLogin={setIsLogin}
                  code_dept={code_dept}
                  info={info_}
                  mon_ecole={mon_ecole}
                />
              ) : (
                <Redirect to="/" />
              )
            }
          />

          <Route
            path="/sec4"
            render={(props) =>
              isLogin ? (
                <SecIV
                  {...props}
                  setIsLogin={setIsLogin}
                  code_dept={code_dept}
                  info={info_}
                  mon_ecole={mon_ecole}
                />
              ) : (
                <Redirect to="/" />
              )
            }
          />

          <Route
            path="/philo"
            render={(props) =>
              isLogin ? (
                <Philo
                  {...props}
                  setIsLogin={setIsLogin}
                  code_dept={code_dept}
                  mon_ecole={mon_ecole}
                  info={info_}
                />
              ) : (
                <Redirect to="/" />
              )
            }
          />

          <Route
            path="/saisie_notes_bac"
            render={(props) =>
              isLogin ? (
                <Saisie_notes_bac
                  {...props}
                  setIsLogin={setIsLogin}
                  code_dept={code_dept}
                  info={info_}
                  mon_ecole={mon_ecole}
                />
              ) : (
                <Redirect to="/" />
              )
            }
          />

          <Route
            path="/mat_anticipees"
            render={(props) =>
              isLogin ? (
                <Mat_anticipees
                  {...props}
                  setIsLogin={setIsLogin}
                  code_dept={code_dept}
                  info={info_}
                  mon_ecole={mon_ecole}
                />
              ) : (
                <Redirect to="/" />
              )
            }
          />

          <Route
            path="/permph"
            render={(props) =>
              isLogin ? (
                <PermPh
                  {...props}
                  setIsLogin={setIsLogin}
                  code_dept={code_dept}
                  info={info_}
                />
              ) : (
                <Redirect to="/" />
              )
            }
          />

          <Route
            path="/permns"
            render={(props) =>
              isLogin ? (
                <PermNs
                  {...props}
                  setIsLogin={setIsLogin}
                  code_dept={code_dept}
                  info={info_}
                />
              ) : (
                <Redirect to="/" />
              )
            }
          />

          <Route
            path="/eni"
            render={(props) =>
              isLogin ? (
                <Eni
                  {...props}
                  setIsLogin={setIsLogin}
                  code_dept={code_dept}
                  info={info_}
                />
              ) : (
                <Redirect to="/" />
              )
            }
          />

          <Route
            path="/enic"
            render={(props) =>
              isLogin ? (
                <Enic
                  {...props}
                  setIsLogin={setIsLogin}
                  code_dept={code_dept}
                  info={info_}
                />
              ) : (
                <Redirect to="/" />
              )
            }
          />

          <Route
            path="/nouveau"
            render={(props) =>
              isLogin ? (
                <Nouveau
                  {...props}
                  setIsLogin={setIsLogin}
                  code_dept={code_dept}
                />
              ) : (
                <Redirect to="/" />
              )
            }
          />

          <Route
            path="/capiste"
            render={(props) =>
              isLogin ? (
                <Capiste {...props} setIsLogin={setIsLogin} />
              ) : (
                <Redirect to="/" />
              )
            }
          />

          <Route
            path="/utilisateur"
            render={(props) =>
              isLogin ? (
                <CreerUtilisateur
                  {...props}
                  setIsLogin={setIsLogin}
                  info={info_}
                />
              ) : (
                <Login {...props} setIsLogin={setIsLogin} />
              )
            }
          />

          <Route
            path="/periode"
            render={(props) =>
              isLogin ? (
                <PeriodeSaisie
                  {...props}
                  setIsLogin={setIsLogin}
                  info={info_}
                />
              ) : (
                <Login {...props} setIsLogin={setIsLogin} />
              )
            }
          />

          <Route
            path="/passutilisateur"
            render={(props) =>
              isLogin ? (
                <ChangerMot2Passe
                  {...props}
                  setIsLogin={setIsLogin}
                  info={info_}
                />
              ) : (
                <Login {...props} setIsLogin={setIsLogin} />
              )
            }
          />

          <Route
            path="/ecole_district"
            render={(props) =>
              isLogin ? (
                <Ecole
                  {...props}
                  setIsLogin={setIsLogin}
                  code_dept={code_dept}
                  mon_ecole={mon_ecole}
                  info={info_}
                />
              ) : (
                <Login {...props} setIsLogin={setIsLogin} />
              )
            }
          />

          <Route
            path="/perm_en_ligne"
            render={(props) => (
              <Bienvenue_perm {...props} setIsLogin={setIsLogin} info={info_} />
            )}
          />

          <Route
            path="/resultatbac"
            render={(props) => (
              <ResultatBac {...props} setIsLogin={setIsLogin} info={info_} />
            )}
          />

          <Route
            path="/demande_resultatbac"
            render={(props) => (
              <ResultatBac {...props} setIsLogin={setIsLogin} info={info_} />
            )}
          />

          <Route
            path="/e_diplome"
            render={(props) => (
              <Ediplome {...props} setIsLogin={setIsLogin} info={info_} />
            )}
          />

          <Route
            path="/e_document"
            render={(props) => (
              <Intro {...props} setIsLogin={setIsLogin} info={info_} />
            )}
          />

          <Route
            path="/verification"
            render={(props) => (
              <Verification_Inscription
                {...props}
                setIsLogin={setIsLogin}
                info={info_}
              />
            )}
          />

          <Route
            path="/verif_diplome"
            render={(props) => (
              <VerifDiplome {...props} setIsLogin={setIsLogin} info={info_} />
            )}
          />

          <Route component={NotFound} />
        </Switch>
      </Suspense>
    </Fragment>
  );
}

export default App;
